import { atom } from 'recoil';
import { FontRecognitionResult } from 'types/FontRecognitionResult';

export const SearchResultState = atom<FontRecognitionResult>({
  key: 'SearchResultState',
  default: {
    fonts: [],
  }
});
